module.exports = __webpack_public_path__ + "assets/img/9.8d9cee31.jpg";